import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { IPublicClientApplication } from "@azure/msal-browser";

import { Button } from "primereact/button";

import { faWarning } from "@fortawesome/pro-regular-svg-icons";
import { faLeftToBracket, faRotate } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { fallbackTranslationKeys } from "../../../../models/app-fallback-translation-keys";

import "./ErrorPageWithActionsPage.scss";

interface IErrorPageWithActionsPageProps {
  pca: IPublicClientApplication;
  titleKey: string;
  descriptionKey: string;
  redirectAction?: () => void;
}

export const ErrorPageWithActionsPage: FunctionComponent<IErrorPageWithActionsPageProps> = (
  props: IErrorPageWithActionsPageProps,
) => {
  const { t } = useTranslation();

  const logout = () => {
    props.pca.logout();
  };

  const reloadPage = () => {
    if (props?.redirectAction) {
      props.redirectAction();
      return;
    }

    window.location.reload();
  };

  return (
    <div className="page-error-page-with-actions">
      <h1 className="header">
        <FontAwesomeIcon icon={faWarning} />
        {t(props.titleKey)}
      </h1>

      <p className="description">{t(props.descriptionKey)}</p>

      <div className="buttons">
        <Button
          onClick={logout}
          label={t(fallbackTranslationKeys.actions.logout)}
          icon={<FontAwesomeIcon icon={faLeftToBracket} />}
        />

        <Button
          onClick={reloadPage}
          label={t(fallbackTranslationKeys.actions.reloadPage)}
          icon={<FontAwesomeIcon icon={faRotate} />}
        />
      </div>
    </div>
  );
};
